import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    retencionTipoId: 0,
    retencionTipo: null,
    retencionTipoNombre: null,
    retencionRegimenId: 0,
    retencionRegimen: null,
    retencionRegimenNombre: null,
    jurisdiccionIngresosBrutosId: 0,
    jurisdiccionIngresosBrutos: null,
    jurisdiccionIngresosBrutosNombre: null,
    importe: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_RETENCION_CLIENTE'(state) {
        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD');
        state.retencionTipoId = 0;
        state.retencionTipo = null;
        state.retencionTipoNombre = null;
        state.retencionRegimenId = 0;
        state.retencionRegimen = null;
        state.retencionRegimenNombre = null;
        state.jurisdiccionIngresosBrutosId = 0;
        state.jurisdiccionIngresosBrutos = null;
        state.jurisdiccionIngresosBrutosNombre = null;
        state.importe = 0;
    },
    'SET_RETENCION_TIPO'(state, retencionTipo) {
        state.retencionTipo = retencionTipo;
        if (retencionTipo) {
            state.retencionTipoId = retencionTipo.id ? retencionTipo.id : 0;
            state.retencionTipoNombre = retencionTipo.nombre ? retencionTipo.nombre.trim() : null;
        } else {
            state.retencionTipoId = 0;
            state.retencionTipoNombre = null;
        }
    },
    'SET_RETENCION_REGIMEN'(state, retencionRegimen) {
        state.retencionRegimen = retencionRegimen;
        if (retencionRegimen) {
            state.retencionRegimenId = retencionRegimen.id ? retencionRegimen.id : 0;
            state.retencionRegimenNombre = retencionRegimen.nombre ? retencionRegimen.nombre.trim() : null;
        } else {
            state.retencionRegimenId = 0;
            state.retencionRegimenNombre = null;
        }
    },
    'SET_JURISDICCION'(state, jurisdiccion) {
        state.jurisdiccionIngresosBrutos = jurisdiccion;
        if (jurisdiccion) {
            state.jurisdiccionIngresosBrutosId = jurisdiccion.id ? jurisdiccion.id : 0;
            state.jurisdiccionIngresosBrutosNombre = jurisdiccion.nombre ? jurisdiccion.nombre.trim() : null;
        } else {
            state.jurisdiccionIngresosBrutosId = 0;
            state.jurisdiccionIngresosBrutosNombre = null;
        }
    },
};

const getters = {
    getField,

    retencionCliente (state) {
        return {
            fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
            retencionTipoId: parseInt(state.retencionTipoId),
            retencionTipo: state.retencionTipo,
            retencionTipoNombre: state.retencionTipoNombre,
            retencionRegimenId: parseInt(state.retencionRegimenId),
            retencionRegimen: state.retencionRegimen,
            retencionRegimenNombre: state.retencionRegimenNombre,
            jurisdiccionIngresosBrutosId: parseInt(state.jurisdiccionIngresosBrutosId),
            jurisdiccionIngresosBrutos: state.jurisdiccionIngresosBrutos,
            jurisdiccionIngresosBrutosNombre: state.jurisdiccionIngresosBrutosNombre,
            importe: parseFloat(state.importe),
        }
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETENCION_CLIENTE');
            resolve();
        }, error => {
            reject(error);
        })
    },
    setRetencionTipo: ({commit}, retencionTipo) => {
        commit('SET_RETENCION_TIPO', retencionTipo);
    },
    setRetencionRegimen: ({commit}, retencionRegimen) => {
        commit('SET_RETENCION_REGIMEN', retencionRegimen);
    },
    setJurisdiccion: ({commit}, jurisdiccion) => {
        commit('SET_JURISDICCION', jurisdiccion);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}